import { Row } from 'antd'
import React from 'react'

function ComputerPhoto({ element, img }) {
  return (
    <Row align="middle" justify="center" style={{ flexDirection: 'column', minHeight: '50vh' }}>
        {element}
        <img width={200} src={img} alt='no-data' />
    </Row>
  )
}

export default ComputerPhoto
